import { useEffect, useRef } from 'react';
import { useWatch } from 'react-hook-form';

import { useFormContext } from '@/components/react-hook-form';

import { HypotheticalTransferFormModalShape } from '../HypotheticalTransferModal.types';

export function useResetSourceSpecificFields(): void {
  const {
    control,
    formState: { defaultValues },
    setValue,
  } = useFormContext<HypotheticalTransferFormModalShape>();
  const sourceId = useWatch({ control, name: 'sourceId' });
  const previousSourceId = useRef(sourceId);
  const previousDefaultSourceId = useRef(defaultValues?.sourceId);

  useEffect(() => {
    const sourceChanged = previousSourceId.current !== sourceId;
    const formWasReset =
      previousDefaultSourceId.current !== defaultValues?.sourceId;

    if (sourceChanged && !formWasReset) {
      setValue('sourceOwnedEntityId', '');
      setValue('sourceInsurancePolicyId', '');
      setValue('_policyOrAsset', null);
      setValue('_activeTransfer', null);
    }

    previousSourceId.current = sourceId;
    previousDefaultSourceId.current = defaultValues?.sourceId;
  }, [defaultValues?.sourceId, setValue, sourceId]);
}
